export default {
  NOIMAGE: 'https://firebasestorage.googleapis.com/v0/b/app-blog-1ef41.appspot.com/o/noimage.png?alt=media&token=4a9cbe2b-20c8-490a-ab94-c39d8f4cab5e',
  CODE: {
    PERMISSION_DENIED: 'permission-denied'
  },
  NOTFOUND_PATH: '/404'
}
